
import RecipeCategory from '@/pages/recipe/cat/_slug.vue';

export default {
  name: 'Recipes',

  components: {
    RecipeCategory,
  },
};
